"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _EmailRegistrationForm = require("./EmailRegistrationForm");
Object.keys(_EmailRegistrationForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EmailRegistrationForm[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EmailRegistrationForm[key];
    }
  });
});